import React,{Component} from "react";

class RenderOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <React.Fragment>
            <option value="">Please Select Question</option>   
            {(this.props.questionData).length > 0 &&
                Object.values(this.props.questionData).map((row, key) => (
                <option value={row.id}>{row.name}</option>
                ))
            }
                     
      </React.Fragment>
    );
  }
}

export default RenderOptions;
